import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { DollarSign, Share2, TrendingUp, Award, CheckCircle } from 'lucide-react';

const Affiliate = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 md:py-4 md:px-6 text-white text-center space-y-1.5 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            Affiliate Partner Program
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Earn Commissions by Sharing Courses</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs max-w-xl mx-auto leading-snug">
            Join the E-Learning Hub Affiliate Program. Promote engineering and technology masterclasses to your network and earn up to 30% commission on every course referral.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div className="bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center space-y-2">
            <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 font-black text-sm flex items-center justify-center mx-auto">
              1
            </div>
            <h3 className="text-xs sm:text-sm font-bold text-gray-900">Sign Up</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Register as an affiliate partner in less than 2 minutes and get your custom referral link.</p>
          </div>

          <div className="bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center space-y-2">
            <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 font-black text-sm flex items-center justify-center mx-auto">
              2
            </div>
            <h3 className="text-xs sm:text-sm font-bold text-gray-900">Share Courses</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Share your referral links on social media, blogs, YouTube, or with engineering communities.</p>
          </div>

          <div className="bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs text-center space-y-2">
            <div className="w-8 h-8 rounded-lg bg-purple-50 text-purple-600 font-black text-sm flex items-center justify-center mx-auto">
              3
            </div>
            <h3 className="text-xs sm:text-sm font-bold text-gray-900">Get Paid</h3>
            <p className="text-[11px] text-gray-500 leading-normal">Receive weekly payouts directly into your bank account or UPI for every successful purchase.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Affiliate;
